import React from "react";
import { Navbar, Footer } from "./../../Components";
import Detail from "./../../Containers/CheckOut/Detail";
import Banner from "../../Containers/Cgu/Banner";
import {default as CguContainer}  from "../../Containers/Cgu/Cgu";
import DocumentMeta from "react-document-meta";

function Cgu() {
    const meta = {
        title: 'Conditions générales d\'utilisation - Vignitus',
        description: 'Les conditions générales d\'utilisation du site vignitus.fr',
        canonical: 'https://vignitus.fr/condition-general-utilisation',
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'Vignitus,CGU'
            }
        }
    };
  return (
      <DocumentMeta {...meta}>
          <div>
          <Navbar />
          <div className="content-wraper">
              <Banner/>
              <CguContainer/>
          </div>
          <Footer />
        </div>
      </DocumentMeta>
  );
}

export default Cgu;
